import React, { FC } from 'react'

import { WithClassName, WithDataName } from 'common/types'
import { useAuthorized } from 'hooks/useAuthorized'

import { TabBarAuthorized } from './TabBar/TabBarAuthorized'
import { TabBarNotAuthorized } from './TabBar/TabBarNotAuthorized'

/**
 * @param isMobileBar - блок с кнопками будет отображаться снизу экрана как на мобильных
 */
export const TabBar: FC<
  { isMobileBar?: boolean } & WithClassName & WithDataName
> = ({ className, isMobileBar = false, ...rest }) => {
  const authorized = useAuthorized()

  if (!authorized) {
    return (
      <TabBarNotAuthorized
        isMobileBar={isMobileBar}
        data-name={rest['data-name']}
        className={className}
      />
    )
  }

  return (
    <TabBarAuthorized
      data-name={rest['data-name']}
      className={className}
      isMobileBar={isMobileBar}
    />
  )
}
